<script>
  import { onMount, onDestroy } from "svelte";
  import { ENGINE_URL } from "../services/service.config";
  import terminalStream from "../services/TerminalStreamService";

  export let environment = "LIVE";
  export let connected = undefined; // undefined: auto-detect via health endpoint/stream

  let isOnline = false;
  let checkTimer = null;
  let unbindStream = null;

  async function checkHealth() {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 3500);
      const res = await fetch(`${ENGINE_URL}/health`, {
        method: "GET",
        signal: controller.signal,
        cache: "no-store",
      });
      clearTimeout(timeoutId);
      isOnline = res.ok;
    } catch (e) {
      isOnline = false;
    }
  }

  onMount(() => {
    if (connected === undefined) {
      checkHealth();
      checkTimer = setInterval(checkHealth, 10000);
      unbindStream = terminalStream.onStatusChange((status) => {
        if (status === "CONNECTED") {
          isOnline = true;
        } else if (status === "DISCONNECTED") {
          checkHealth();
        }
      });
    }
  });

  onDestroy(() => {
    if (checkTimer) clearInterval(checkTimer);
    if (unbindStream) unbindStream();
  });

  $: isConnected = (connected !== undefined) ? Boolean(connected) : isOnline;
</script>

<div
  class="env-badge-institutional {isConnected ? 'online' : 'offline'}"
  title={isConnected ? "Trading Engine Connected (LIVE)" : "Trading Engine Disconnected (OFFLINE)"}
>
  <span class="live-dot {isConnected ? 'online' : 'offline'}"></span>
  <span class="live-text {isConnected ? 'online' : 'offline'}">
    {isConnected ? 'LIVE' : 'OFFLINE'}
  </span>
</div>

<style>
  .env-badge-institutional {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border-radius: 16px;
    padding: 3px 10px;
    user-select: none;
    transition: all 0.3s ease;
  }
  .env-badge-institutional.online {
    background: rgba(22, 163, 74, 0.12);
    border: 1px solid rgba(34, 197, 94, 0.35);
  }
  .env-badge-institutional.offline {
    background: rgba(239, 68, 68, 0.12);
    border: 1px solid rgba(239, 68, 68, 0.35);
  }
  .live-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    transition: all 0.3s ease;
  }
  .live-dot.online {
    background: #22c55e;
    box-shadow: 0 0 6px #22c55e;
  }
  .live-dot.offline {
    background: #ef4444;
    box-shadow: 0 0 6px #ef4444;
  }
  .live-text {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.5px;
    transition: all 0.3s ease;
  }
  .live-text.online {
    color: #4ade80;
  }
  .live-text.offline {
    color: #f87171;
  }
</style>
